<div class="modal-header">
  <h4 class="modal-title">{{ pageTitle }}</h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.close(quotation)"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="toolbar text-right">
    <button
      class="btn btn-primary"
      *ngIf="authService.loginUser.role != 2"
      (click)="editVariants()"
      [translate]="'BUTTONS.UPDATE_VARIANTS'"
    >
      <i class="fas fa-edit"></i> Update Variants
    </button>
    &nbsp;
    <button
      class="btn btn-brand"
      *ngIf="authService.loginUser.role != 2"
      (click)="showVariantQuoteForm()"
      [translate]="'BUTTONS.NEW_VARIANT_QUOTATION'"
    >
      <i class="fas fa-plus"></i> Add New Variant Quotation
    </button>
    &nbsp;
    <button
      class="btn btn-info"
      (click)="viewClientInfo()"
      [translate]="'BUTTONS.VIEW_CLIENT_INFO'"
    >
      <i class="fas fa-user-tie"></i> View Client Info
    </button>
  </div>
  <div class="quotation-block">
    <table
      class="table table-hover"
      *ngIf="settingsSvc.masterfile$ | async as settings"
    >
      <thead>
        <tr>
          <th>&nbsp;</th>
          <th [translate]="'TITLES.TIERED_PRICING'">TIERED PRICING</th>
          <th [translate]="'TITLES.LEAD_TIME'" class="text-center">LEAD TIME</th>
          <th [translate]="'TITLES.SAMPLE_DETAILS'" class="text-center"
            >SAMPLE DETAIL</th
          >
          <!-- <th [translate]="'TITLES.QUOTATION_NOTES'">NOTES</th> -->
          <th [translate]="'TITLES.FILES'">FILES</th>
          <th [translate]="'TITLES.VARIANTS'" class="text-center">Variant</th>
          <th width="80" *ngIf="authService.loginUser.role != 2">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="quotesService.gettingRecords">
          <td colspan="8" class="text-center">
            <br />
            <h6 [translate]="'GENERAL.GETTING_RECORDS'">
              <i class="fas fa-spinner fa-spin"></i> Getting records...
            </h6>
            <br />
          </td>
        </tr>
        <tr *ngFor="let r of variantQuotes; let i = index">
          <td align="center">
            <img
              [src]="url + '/file?f=' + (r.photo != '' ? r.photo : noImgUrl)"
              width="150"
              alt=""
            />
          </td>
          <td>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th [translate]="'GENERAL.QUANTITY'">QUANTITY</th>
                  <th *ngIf="r.logistic_1">
                    {{ settings.LOGISTICS[r.logistic_1] | translate }}
                  </th>
                  <th *ngIf="r.logistic_2">
                    {{ settings.LOGISTICS[r.logistic_2] | translate }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let tp of r.tiered_pricing_json; let i = index">
                  <td>{{ tp.quantity }}</td>
                  <td *ngIf="r.logistic_1">
                    {{ tp.logistic_1 | currency: '' : 'symbol' : '1.2-4' }}
                    <span class="text-success font-500">
                      [{{
                        tp.logistic_1 +
                          (tp.logistic_1 * tp.logistic_1_markup_percent) / 100
                          | currency: '' : 'symbol' : '1.2-4'
                      }}]
                    </span>
                  </td>
                  <td *ngIf="r.logistic_2">
                    {{ tp.logistic_2 | currency: '' : 'symbol' : '1.2-4' }}
                    <span class="text-success font-500">
                      [{{
                        tp.logistic_2 +
                          (tp.logistic_2 * tp.logistic_2_markup_percent) / 100
                          | currency: '' : 'symbol' : '1.2-4'
                      }}]
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>

            <div> <b>Notes:</b> {{ r.notes }}</div>
          </td>
          <td align="center">
            <div class="lead-time" *ngIf="r.logistic_1">
              <div class="days"
                >{{ settingsSvc.getLeadTime(r.logistic_1, r.lead_time_days_log1) }}
                {{ 'GENERAL.DAYS' | translate }}</div
              >
              <div class="desc">{{
                settings.LOGISTICS[r.logistic_1] | translate
              }}</div>
            </div>
            <br />
            <div class="lead-time" *ngIf="r.logistic_2">
              <div class="days"
                >{{ settingsSvc.getLeadTime(r.logistic_2, r.lead_time_days_log1) }}
                {{ 'GENERAL.DAYS' | translate }}</div
              >
              <div class="desc">{{
                settings.LOGISTICS[r.logistic_2] | translate
              }}</div>
            </div>
          </td>
          <td align="center">
            <div class="lead-time">
              <div class="days">{{
                r.sample_price | currency: '' : 'symbol' : '1.2-4'
              }}</div>
              <div class="desc">{{ 'GENERAL.PRICE' | translate }}</div>
            </div>
            <br />
            <div class="lead-time">
              <div class="days">{{ r.sample_lead_time_days }} days</div>
              <div class="desc">{{ 'TITLES.LEAD_TIME' | translate }}</div>
            </div>
          </td>
          <!-- <td align="center">
                        <div class="lead-time" *ngIf="r.logistic_1">
                            <div class="days">{{ r.lead_time_days_log1 }} {{ "GENERAL.DAYS" | translate }}</div>
                            <div class="desc">{{ settings.LOGISTICS[r.logistic_1] | translate }}</div>
                        </div>
                        <br />
                        <div class="lead-time" *ngIf="r.logistic_2">
                            <div class="days">{{ r.lead_time_days_log2 }} {{ "GENERAL.DAYS" | translate }}</div>
                            <div class="desc">{{ settings.LOGISTICS[r.logistic_2] | translate }}</div>
                        </div>
                    </td>
                    <td align="center">
                        <div class="lead-time">
                            <div class="days">{{ r.sample_price | currency: "":"symbol":"1.2-4" }}</div>
                            <div class="desc">{{ "GENERAL.PRICE" | translate }}</div>
                        </div>
                        <br />
                        <div class="lead-time">
                            <div class="days">{{ r.sample_lead_time_days }} days</div>
                            <div class="desc">{{ "TITLES.LEAD_TIME" | translate }}</div>
                        </div>
                    </td> -->
          <!-- <td>{{r.notes}}</td> -->
          <td>
            <ul *ngFor="let file of r.quotation_attachments; let fidx = index">
              <li>
                <a [attr.href]="url + '/file?f=' + file.name" target="_blank"
                  >File {{ fidx + 1 }}</a
                >
              </li>
            </ul>
          </td>
          <td class="quote-variants">
            <table class="table">
              <tbody>
                <tr *ngFor="let v of r.variants | keyvalue">
                  <td>
                    <b>{{ v.key }}:</b> {{ v.value }}
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td class="actions text-center" *ngIf="authService.loginUser.role != 2">
            <div>
              <a
                href="javascript:;"
                title="{{ 'TEXT.EDIT_RECORD' | translate }}"
                class="text-success"
                (click)="showVariantQuoteForm(r)"
              >
                <mat-icon
                  class="mat-icon"
                  color="primary"
                  role="img"
                  aria-hidden="true"
                  >edit
                </mat-icon>
              </a>
              <a
                href="javascript:;"
                title="{{ 'TEXT.DELETE_RECORD' | translate }}"
                class="text-danger"
                (click)="delete(r)"
              >
                <mat-icon
                  class="mat-icon"
                  color="warn"
                  role="img"
                  aria-hidden="true"
                  >delete
                </mat-icon>
              </a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-danger"
    (click)="activeModal.close(quotation)"
    [translate]="'BUTTONS.CLOSE'"
  >
    <i class="fas fa-times"></i> Close
  </button>
</div>
